import PubSubEventHub from '@utils/events/PubSubEventHub'
import { formValueChanged } from '@utils/events/eventCodes'

import styles from 'styles/Checkbox.module.css'

const eventHub = new PubSubEventHub()

const Checkbox = ({
	formEvent,
	id,
	jsx,
	label,
	labelMinWidth,
	name,
	onClick,
	register = () => null,
	style,
	validations,

	...rest
}) => {
	const minWidthStyle = labelMinWidth
		? { minWidth: labelMinWidth }
		: {}
	const _onClick = (e) => {
		if (onClick) onClick(e)
		if (formEvent)
			eventHub.emit(PubSubEventHub.createEvent(formValueChanged))
	}

	return (
		<label
			htmlFor={id || name}
			className={styles.label}
			style={{ ...minWidthStyle, ...(style || {}) }}
		>
			<input
				{...rest}
				{...register(name, validations)}
				className={styles.input}
				id={id || name}
				name={name}
				onClick={_onClick}
				type="checkbox"
			/>

			{
				<span className={styles.span} required={rest.required}>
					{jsx || label}
				</span>
			}
		</label>
	)
}

export default Checkbox
